import { render, staticRenderFns } from "./PopoverModal.vue?vue&type=template&id=91b0a2f6&"
import script from "./PopoverModal.vue?vue&type=script&lang=js&"
export * from "./PopoverModal.vue?vue&type=script&lang=js&"
import style0 from "./PopoverModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports